// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
}
.plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C .plannersListPage_right__58DWL {
  display: flex;
  align-items: center;
  gap: 20px;
}
.plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C .plannersListPage_right__58DWL .plannersListPage_date__r6Feh {
  display: flex;
  align-items: center;
  gap: 4px;
}
.plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C .plannersListPage_right__58DWL .plannersListPage_date__r6Feh img,
.plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C .plannersListPage_right__58DWL .plannersListPage_date__r6Feh svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C .plannersListPage_right__58DWL .plannersListPage_date__r6Feh span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

@media (max-width: 767px) {
  .plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C {
    padding: 16px;
  }
  .plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C .plannersListPage_right__58DWL {
    gap: 12px;
  }
  .plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C .plannersListPage_right__58DWL button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
}
@media (max-width: 425px) {
  .plannersListPage_pageWrap__65L6O .plannersListPage_pageHeader__HlP6C .plannersListPage_right__58DWL .plannersListPage_date__r6Feh span {
    display: none;
  }
}
.plannersListPage_VendorsListModalBody__CmPgA {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_label__PG8te {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ {
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background-color: var(--white);
  margin-bottom: 16px;
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ h4 {
  font: var(--body-font-two);
  font-weight: 600;
  margin-bottom: 16px;
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ ul {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ ul li .plannersListPage_heading__8ivGT {
  font: var(--body-font-three);
  color: var(--primary-Text);
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ ul li .plannersListPage_value__TtE9M {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ .plannersListPage_requirements__q6L4j {
  padding-top: 16px;
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ .plannersListPage_requirements__q6L4j .plannersListPage_heading__8ivGT {
  font: var(--body-font-three);
  color: var(--primary-Text);
  margin-bottom: 8px;
}
.plannersListPage_VendorsListModalBody__CmPgA .plannersListPage_summary__PKY7\\+ .plannersListPage_requirements__q6L4j .plannersListPage_value__TtE9M {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
}`, "",{"version":3,"sources":["webpack://./src/pages/planners-list/plannersListPage.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;;AASA;EAEE;IACC,aAAA;EAPD;EASC;IACC,SAAA;EAPF;EASE;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAPH;AACF;AAaA;EAKK;IACC,aAAA;EAfJ;AACF;AAuBA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AArBD;AAuBC;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AArBF;AAwBC;EACC,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AAtBF;AAwBE;EACC,0BAAA;EACA,gBAAA;EACA,mBAAA;AAtBH;AAyBE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAvBH;AAyBG;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAvBJ;AAyBI;EACC,4BAAA;EACA,0BAAA;AAvBL;AA0BI;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAxBL;AA6BE;EACC,iBAAA;AA3BH;AA6BG;EACC,4BAAA;EACA,0BAAA;EACA,kBAAA;AA3BJ;AA8BG;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AA5BJ","sourcesContent":[".pageWrap {\r\n\t.pageHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t.right {\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\t.right {\r\n\t\t\t\t.date {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n.VendorsListModalBody {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 16px;\r\n\r\n\t.label {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tdisplay: block;\r\n\t\tmargin-bottom: 4px;\r\n\t}\r\n\r\n\t.summary {\r\n\t\tpadding: 16px;\r\n\t\tborder: 1px solid var(--border);\r\n\t\tborder-radius: 8px;\r\n\t\tbackground-color: var(--white);\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\th4 {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tmargin-bottom: 16px;\r\n\t\t}\r\n\r\n\t\tul {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 16px;\r\n\t\t\tpadding-bottom: 16px;\r\n\r\n\t\t\tli {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 16px;\r\n\r\n\t\t\t\t.heading {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.value {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.requirements {\r\n\t\t\tpadding-top: 16px;\r\n\r\n\t\t\t.heading {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tmargin-bottom: 8px;\r\n\t\t\t}\r\n\r\n\t\t\t.value {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `plannersListPage_pageWrap__65L6O`,
	"pageHeader": `plannersListPage_pageHeader__HlP6C`,
	"right": `plannersListPage_right__58DWL`,
	"date": `plannersListPage_date__r6Feh`,
	"VendorsListModalBody": `plannersListPage_VendorsListModalBody__CmPgA`,
	"label": `plannersListPage_label__PG8te`,
	"summary": `plannersListPage_summary__PKY7+`,
	"heading": `plannersListPage_heading__8ivGT`,
	"value": `plannersListPage_value__TtE9M`,
	"requirements": `plannersListPage_requirements__q6L4j`
};
export default ___CSS_LOADER_EXPORT___;
